import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import DemeritEducationReservationFailBottomSheet from '@di-shared/features/public-service/demerit-education/DemeritEducationReservationFailBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function DemeritEducationReservationFailBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <DemeritEducationReservationFailBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
